export default defineNuxtPlugin((nuxtApp) => {
    const consentAnalytics = localStorage.getItem('silktideCookieChoice_performance') === 'true' ? true : false;

    if(!consentAnalytics) {
        return;
    }

    const debounce = (func, wait = 150) => {
        let timeout; // This variable will store the timeout ID

        // The returned function will be our event handler
        return function(...args) {
            const context = this;

            // Clear the previous timeout any time the function is called again
            clearTimeout(timeout);

            // Set a new timeout that will call the original function after 'wait' milliseconds
            timeout = setTimeout(() => {
                // Use apply to ensure 'this' and arguments (like the event object) are correct
                func.apply(context, args);
            }, wait);
        };
    };

    (function(d, w, c) {
        w.BrevoConversationsID = useRuntimeConfig().public.brevoChatID;
        w[c] = w[c] || function() {
            (w[c].q = w[c].q || []).push(arguments);
        };
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
        if (d.head) d.head.appendChild(s);
    })(document, window, 'BrevoConversations');

    window.BrevoConversationsSetup = {
        language: document.documentElement.lang,
        buttonSize: 40,
        setChatWidth: 300
    };

    const resetBrevo = () => {
        if(window.innerWidth >= 1024) {
            BrevoConversations('setChatWidth', 300);
            BrevoConversations('restart');
        }
    };

    const debouncedResizeHandler = debounce(resetBrevo, 250);

    window.addEventListener('resize', debouncedResizeHandler);

    window.addEventListener('consentPerformanceAccept', () => {
        BrevoConversations('show');
    });

    window.addEventListener('consentPerformanceReject', () => {
        BrevoConversations('hide');
    });
});

